import * as API from '@/services';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import { formatWorkerAuditMonitoringList } from './worker-audit-monitoring.helper';
import { WorkerAuditMonitoringActions } from './worker-audit-monitoring.redux';
import { IPayloadGetWorkerAuditMonitoringListRequest } from './worker-audit-monitoring.type';

export function* getWorkerAuditMonitoringListSaga(
	action: PayloadAction<IPayloadGetWorkerAuditMonitoringListRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetWorkerAuditMonitoringListResponse> =
			yield API.getWorkerAuditMonitoringList({ ...rest });
		const content = formatWorkerAuditMonitoringList(res?.data?.content, {
			total: res?.data?.total,
			page: rest.page,
			pageSize: rest.pageSize,
		});

		yield put(
			WorkerAuditMonitoringActions.getWorkerAuditMonitoringListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(
			WorkerAuditMonitoringActions.getWorkerAuditMonitoringListFailure()
		);
	}
}
